import { orderDetail, orderCancel, orderPaySign } from '@/services/payment'
import { OrderDetail as OrderDetailType, OrderPaysignRes } from '@/services/types/payment'
import { useState, useMemo, useEffect, HTMLAttributes } from 'react'
import SJCard from '@/components/SJCard'
import icons from '@/assets/icons'
import dayjs from 'dayjs'
import SJButton from '@/components/SJButton'
import { useInterval } from 'ahooks'
import { QRCodeCanvas } from 'qrcode.react'
import SJSite from '@/components/SJSite'
import { useNavigate, useSearchParams } from 'react-router-dom'
import './index.less'
import { Dialog } from 'antd-mobile'

const OrderDetail = () => {
  document.title = '订单详情'
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const orderCode = searchParams.get('orderCode') || ''

  const [order, setOrder] = useState<OrderDetailType>()
  const fetchOrder = async () => {
    if (!orderCode) return
    try {
      const res = (await orderDetail(orderCode)) as unknown as OrderDetailType
      setOrder(res)
    } catch (error) {}
  }

  useEffect(() => {
    fetchOrder()
  }, [])

  const handleCancel = () => {
    Dialog.confirm({
      title: '取消订单',
      content: '订单取消后无法恢复，是否确定取消订单？',
      onConfirm: async () => {
        try {
          await orderCancel(orderCode)
          fetchOrder()
        } catch (error) {}
      },
    })
  }

  const handlePay = async () => {
    if (orderCode) {
      const res = (await orderPaySign(orderCode)) as unknown as OrderPaysignRes
      console.log(res)
      // Taro.requestPayment({
      //   ...res,
      //   success: (ret) => {
      //     console.log(ret)
      //     fetchOrder()
      //   },
      //   fail: (err) => {
      //     log.error('requestPayment', err)
      //   },
      // })
    }
  }

  const handleBack = () => {
    navigate('/order/back', { state: { orderCode: orderCode, amount: order?.amount } })
  }

  const GradeIcon = (grade: number) => {
    return icons[`IconGrade${grade || 16}`]
  }

  const getOrderStatus = (_order: OrderDetailType) => {
    return _order.status === 1 && ['examining', 'examined'].includes(_order.examinationState)
      ? 7
      : _order.status === 1 && ['failed'].includes(_order.examinationState)
      ? 1
      : _order.status
  }

  return (
    <div className="page order-detail">
      {order ? (
        <div className="main">
          {/* status */}
          <OrderStatus
            status={getOrderStatus(order)}
            orderTime={order.orderTime}
            onSuccess={fetchOrder}
          />
          {/* info */}
          <SJCard className="section-item section-product">
            <div className="info-item info-grade">
              <img className="grade" src={GradeIcon(order.grade)} alt="" />
              <div className="name flex-1">{order.productName}</div>
            </div>
            <InfoItem title="考生：" detail={order.applicantName}></InfoItem>
            <InfoItem title="证件号：" detail={order.identificationNum}></InfoItem>
            {order.status === 1 && order.registrationNum && (
              <OrderQrcode qrcode={order.registrationNum}></OrderQrcode>
            )}
          </SJCard>
          {/* fee */}
          <SJCard className="section-item">
            <InfoItem title="报名费用：" detail={'¥' + order.amount}></InfoItem>
            {order.status === 0 ? (
              <div className="info-item pay">
                <span className="label">需支付：</span>
                <span className="value">¥{order.amount}</span>
              </div>
            ) : (
              <>
                {order.couponAmount > 0 && (
                  <InfoItem
                    title="优惠券："
                    detail={'-¥' + order.couponAmount}
                    detailStyle={{ color: '#FF2E00' }}
                  ></InfoItem>
                )}
                <div className="info-item payed">
                  <span className="label">实付款：</span>
                  <span className="value">¥{order.payAmount}</span>
                </div>
              </>
            )}
          </SJCard>
          {/* order */}
          <SJCard className="section-item">
            <InfoItem title="订单编号：" detail={OrderCode(order.orderCode)}></InfoItem>
            {order.orderTime && (
              <InfoItem
                title="下单时间："
                detail={dayjs(Number(order.orderTime)).format('YYYY-MM-DD HH:mm:ss')}
              ></InfoItem>
            )}
            {order.tradeTime && (
              <InfoItem
                title="支付时间："
                detail={dayjs(Number(order.tradeTime)).format('YYYY-MM-DD HH:mm:ss')}
              ></InfoItem>
            )}
          </SJCard>
          {/* actions */}
          <div className="actions">
            {order.status === 0 && (
              <>
                <SJButton className="btn-pay" type="primary" onClick={handlePay}>
                  去支付
                </SJButton>
                <span className="btn-cancel" onClick={handleCancel}>
                  取消订单
                </span>
              </>
            )}
            {/* 订单已支付，非优惠券支付，非评测中，评测完成 */}
            {order.status === 1 &&
              !['examining', 'examined', 'failed'].includes(order.examinationState) &&
              order.type !== 2 && (
                <span className="btn-cancel" onClick={handleBack}>
                  申请退款
                </span>
              )}
          </div>
        </div>
      ) : (
        <SJSite />
      )}
    </div>
  )
}
// 倒计时
type TimeCountDownProps = {
  seconds: number
  onSuccess?: () => void
}
const TimeCountDown = ({ seconds, onSuccess }: TimeCountDownProps) => {
  // 倒计时
  const [second, setSecond] = useState(seconds) // 倒计时 总时间
  const [interval, setInterval] = useState<number | undefined>(1000) // 倒计时 频率

  const intervalText = useMemo(() => {
    return `${Math.floor(second / 60)}分${second % 60}秒`
  }, [second])

  useInterval(() => {
    if (second === 1) {
      setSecond(0)
      onSuccess && onSuccess()
      setInterval(undefined)
      return
    }
    setSecond(second - 1)
    return () => {
      setInterval(undefined)
    }
  }, interval)

  useEffect(() => {
    console.log('useEffect seconds', seconds)
    setSecond(seconds)
  }, [seconds])

  return <span>{intervalText}</span>
}
// 订单状态
type OrderStatusProps = {
  status: number
  orderTime: number
  onSuccess?: () => void
  onClick?: () => void
}
const OrderStatus = ({ status, orderTime, onClick, onSuccess }: OrderStatusProps) => {
  // 0、待付款、1、已支付、2、退款中、3、已关闭(未支付自动关闭订单） 4、退款成功 5、退款失败 6、已取消（用户手动取消）
  const Status = ['待付款', '已支付', '退款中', '已关闭', '已关闭', '已关闭', '已关闭', '已完成'] // 已完成是 支付成功+评测完成
  const StatusText = [
    '订单将在剩余时间结束后自动关闭',
    '请通过机器人扫码验证进行评测',
    '系统将在1-3个工作日内退款至您的账户',
    '支付超时',
    '退款成功',
    '退款失败',
    '订单已取消',
    '',
  ]
  const StatusIcon = [
    '',
    icons.IconSuccess,
    icons.IconPending,
    icons.IconEnding,
    icons.IconEnding,
    icons.IconEnding,
    icons.IconEnding,
    icons.IconSuccess,
  ]

  const [endSeconds, setEndSeconds] = useState(0)
  useEffect(() => {
    console.log('useEffect orderTime', orderTime)
    setEndSeconds(Math.floor((orderTime + 30 * 60 * 1000 - Date.now()) / 1000))
  }, [orderTime])
  useEffect(() => {
    console.log('useDidShow orderTime', orderTime)
    orderTime && setEndSeconds(Math.floor((orderTime + 30 * 60 * 1000 - Date.now()) / 1000))
  }, [])

  return (
    <SJCard className="section-status" onClick={onClick}>
      <div className={`status status-${status}`}>
        {StatusIcon[status] && <img src={StatusIcon[status]} alt="" />}
        <span>{Status[status]}</span>
        {status === 0 && (
          <span className="countdown">
            :{' '}
            {endSeconds > 0 ? (
              <TimeCountDown seconds={endSeconds} onSuccess={onSuccess} />
            ) : undefined}
          </span>
        )}
      </div>
      <div className="desc">{StatusText[status]}</div>
    </SJCard>
  )
}

const OrderQrcode = ({ qrcode }: { qrcode: string }) => {
  const [showQrcode, setShowQrcode] = useState(false)
  return (
    <div className={`qrcode-item ${showQrcode ? '' : 'hide'}`}>
      <div className="qrcode-title" onClick={() => setShowQrcode(!showQrcode)}>
        <span>凭二维码在机器人中进行评测</span>
        <img src={icons.IconRight} alt="" />
      </div>
      <QRCodeCanvas className="qrcode" size={240} value={qrcode} level="L" />,
    </div>
  )
}

type InfoItemProps = HTMLAttributes<HTMLDivElement> & {
  title: string
  detail?: any
  detailStyle?: any
  indicator?: boolean
  onClick?: () => void
}
const InfoItem = ({ title, detail, detailStyle, onClick, ...rest }: InfoItemProps) => {
  return (
    <div className="info-item" {...rest}>
      <span className="label">{title}</span>
      {typeof detail === 'string' ? (
        <span className="value" style={detailStyle}>
          {detail}
        </span>
      ) : (
        detail
      )}
    </div>
  )
}

const OrderCode = (code: string) => {
  const handleCopy = () => {
    // Taro.setClipboardData({
    //   data: code,
    //   success() {
    //     Taro.getClipboardData({
    //       success(res) {
    //         console.log(res.data) // data
    //       },
    //     })
    //   },
    // })
  }
  return (
    <>
      <span className="value">{code}</span>
      <img src={icons.IconCopy} className="copy" onClick={handleCopy} alt="" />
    </>
  )
}

export default OrderDetail
